{
  "kk": {
    "savedPassengers": {
      "title": "Сақталған жолаушылар",
      "noSavedPassengers": "Сақталған жолаушылар жоқ",
      "autoSaveAfterBooking": "Брондау аяқталғаннан кейін олар сіздің жеке кабинетіңізде автоматты түрде сақталады",
      "enterPassengerManuallyButton": "Жолаушыларды қолмен енгізу"
    }
  },
  "ru": {
    "savedPassengers": {
      "title": "Сохраненные пассажиры",
      "noSavedPassengers": "Нет сохраненных пассажиров",
      "autoSaveAfterBooking": "После бронирования они сохранятся автоматически в личном кабинете",
      "enterPassengerManuallyButton": "Ввести пассажиров вручную"
    }
  },
  "en": {
    "savedPassengers": {
      "title": "Saved passengers",
      "noSavedPassengers": "No saved passengers",
      "autoSaveAfterBooking": "After booking, they will be automatically saved in your personal account",
      "enterPassengerManuallyButton": "Enter passengers manually"
    }
  }
}
